import { NotificationState } from '@/states'

const useNotification = (): NotificationReturnTypes => {
    const { Open, Close } = NotificationState()

    const InitNotification = (message: string) => {
        const id = Date.now()

        Open({ Id: id, Title: message })
        setTimeout(() => Close(id), 2000)
    }

    return {
        InitNotification
    }
}

export default useNotification
